const DEBUG = process.env.NODE_ENV === "production";
import axios from 'axios';
import store from './store';
import router from './router';
import ls from './localstorage';

// here we declare the user tokens for authentication
// let userToken = ls.passport || sessionStorage.

// This part runs only on full page load
var userToken = localStorage.ticket || null;
userToken = JSON.parse(userToken);

let fansData = ls.fansData || null;
fansData = JSON.parse(fansData);

// let fansData = true;

// creating unique sting in base64
var encodedString = btoa("_$_MDD$___F53cd");

var instance = axios.create({
    // baseURL: "https://matchdaydeals.com/api/",
    baseURL: store.state.rawURI,
    // timeout: 120000,
    // headers: {"Authorization": ("Bearer " + (userToken !== null ? userToken[0].token : null)), "Content-Type": "application/json; charset=utf-8;text/html","M_Flid":encodedString,"M-Channel": "web" }
    headers: {"Authorization": ("Bearer " + (userToken !== null ? userToken[0].token : null)), "Content-Type": "application/json; charset=utf-8;text/html" }
  });

router.beforeEach((to, from, next) => {
    // console.log(to)
    // fansData = ls.fansData || null;
    fansData = true;
    // check is user is sent to login page while being logged in
    if(to.path == "/auth/login" && fansData) {
        // send user to dashboard if user is logged in
        next("/home");
    }else if(to.path !== "/auth/login" && to.path !== "/auth/login" && !fansData ) {
        // if user is sent to login and is not logged in
        next("/auth/login");
    }else {
        next();
    }

})

instance.interceptors.request.use((config) => {
    // Ensure requests use the latest token that exists in the local storage
    var userToken = localStorage.ticket || null;
    userToken = JSON.parse(userToken);
    config.headers["Authorization"] = "Bearer " + (userToken !== null ? userToken[0].token : null);
    return config;
},(error) => {
    if (DEBUG) {
        // console.error("✉️ ", error);
    }
    return Promise.reject(error);
});

instance.interceptors.response.use( (response) => {
    // Return a successful response back to the calling service
    let session;
    let localCheck = 1;
    if(localStorage.ticket){
        session = JSON.parse(localStorage.ticket);
    }
    // here you can now pass in the token regeneration script instance
    return response;
},(error) => {
    try{
        if(error.response.status === 401 && error.response.data.message !== "Authentication Failure." ){
            // console.log("error",error.response.data.message);
            // store.commit("logout");
            // window.location = "/";
        }
        else {
            return Promise.reject(error);
        }
    }
    catch(e) {
        return Promise.reject(error);
    }
});


export default instance;
